import React, { useEffect, useRef, useState } from "react";

const Facilities = () => {
  const panIndiaRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Intersection Observer to trigger animation when visible
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (panIndiaRef.current) {
      observer.observe(panIndiaRef.current);
    }

    return () => {
      if (panIndiaRef.current) {
        observer.unobserve(panIndiaRef.current);
      }
    };
  }, []);

  const headingWords = ["Pan", "India", "Presence"];

  return (
    <div className="w-full">
      {/* Facilities Section */}
      <div className="text-center py-10 mt-[8%] md:mt-[5%] px-4">
        <h2 className="text-4xl font-bold text-shadow">Our facilities</h2>
        <div className="mt-8 flex flex-col md:flex-row justify-center items-center gap-6">
          <div className="w-full md:w-1/3 rounded-lg overflow-hidden">
            <img
              src="facility (1).svg"
              alt="Production Floor"
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="w-full md:w-1/3 rounded-lg overflow-hidden">
            <img
              src="facility (2).svg"
              alt="R&D Center"
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="w-full md:w-1/3 rounded-lg overflow-hidden">
            <img
              src="facility (3).svg"
              alt="Quality Control"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>

      {/* Pan India Presence Section */}
      <div className="text-center my-10 px-4">
        <h2 className="typewriter-heading text-3xl md:text-4xl text-shadow font-bold text-blue-600">
          <span className="typewriter-text">Pan India Presence</span>
        </h2>
      </div>

      <div className="flex justify-center">
        <img
          src="pan.gif"
          className="w-[80%] md:w-[36%] rounded-lg mb-10 shadow-lg"
          alt=""
        />
      </div>

      {/* Certifications Section */}
      <div className="bg-[#02347B] text-white py-10 px-4">
        <h2 className="text-center text-3xl font-semibold mb-8">
          Certifications and Standards
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-6 max-w-5xl mx-auto">
          <div className="bg-white text-black rounded-lg p-4 text-center w-[14rem]">
            <h3 className="font-semibold">ISO 9001:2015</h3>
            <p className="text-sm">Quality Management Systems</p>
          </div>
          <div className="bg-white text-black rounded-lg p-4 text-center w-[14rem]">
            <h3 className="font-semibold">Origin</h3>
            <p className="text-sm">India</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facilities;
